import store from "@/store";

/** Módulo liberado para o perfil do usuário logado (configurado em Administração > Configurações). */
export async function moduloAtivo(chave) {
  await store.dispatch("AppConfigurations/garantirModulos");
  return store.getters["AppConfigurations/moduloAtivo"](chave);
}

/** Guard que exige o módulo antes de rodar o guard original da rota (se houver). */
export function comModulo(chave, guardOriginal = null) {
  return async (to, from, next) => {
    if (!(await moduloAtivo(chave))) {
      return next({ name: "home" });
    }
    return guardOriginal ? guardOriginal(to, from, next) : next();
  };
}

/** Aplica comModulo nas rotas listadas em { nomeDaRota: chaveDoModulo }. */
export function aplicarModulos(rotas, moduloPorRota) {
  return rotas.map((rota) => {
    const chave = moduloPorRota[rota.name];
    return chave ? { ...rota, beforeEnter: comModulo(chave, rota.beforeEnter) } : rota;
  });
}
